import UserContext from "Context/UserProvider";
import { useContext } from "react";
import { useNavigate } from "react-router";
import DashboardCard from '../common/DashboardCard';
import { Box, Typography, Button, Stack } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import BusinessIcon from '@mui/icons-material/Business';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { useApiService } from '../../../services/ApiService/ApiService';
import toast from 'react-hot-toast';

function RecentFleets(props: any) {
    const dashboardInfo = props.dashboardInfo;
    const { userInfo, setUserInfo } = useContext(UserContext);
    const navigate = useNavigate();
    const { fetchWithAuth } = useApiService();

    async function selectFleet(fleetUuid: any, fleetName: any, businessName: any, businessUuid: any) {
        try {
            const response = await fetchWithAuth('/fleet/active/set', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    fleetUuid: fleetUuid,
                    accountUuid: userInfo.accountUuid
                })
            });

            if (!response.ok) {
                throw new Error('Failed to set active fleet');
            }

            const res_json = await response.json();
            setUserInfo((prev: any) => ({
                ...prev,
                businessName: businessName,
                businessUuid: businessUuid,
                fleetUuid: fleetUuid,
                currentFleetName: fleetName,
            }));
            navigate("/plan/dashboard");
        } catch (error) {
            console.error('Error setting active fleet:', error);
            toast.error('Failed to set active fleet');
        }
    }

    return (
        <DashboardCard
            title="Recent Fleets"
            icon={<FormatListNumberedIcon />}
            accentColor="secondary"
            actions={
                <Stack direction="row" spacing={2}>
                    <Button
                        startIcon={<AddIcon />}
                        onClick={() =>
                            navigate("/common/add-business-fleet", {
                                state: {
                                    optionCategory: [false, true],
                                    business: {
                                        name: userInfo.businessName,
                                        uuid: userInfo.businessUuid,
                                    },
                                },
                            })
                        }
                    >
                        Add Fleet
                    </Button>
                    <Button
                        startIcon={<BusinessIcon />}
                        onClick={() =>
                            navigate("/common/add-business-fleet", {
                                state: {
                                    optionCategory: [true, false],
                                    business: {
                                        name: userInfo.businessName,
                                        uuid: userInfo.businessUuid,
                                    },
                                },
                            })
                        }
                    >
                        Add Business
                    </Button>
                </Stack>
            }
        >
            <Stack spacing={2}>
                {dashboardInfo.fleetsLastActiveFleets?.map((fleet: any, index: number) => (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            cursor: 'pointer',
                            '&:hover': {
                                color: 'secondary.main'
                            }
                        }}
                        onClick={() =>
                            selectFleet(
                                fleet.fleetUuid,
                                fleet.name,
                                fleet.businessName,
                                fleet.businessUuid
                            )
                        }
                    >
                        <Typography variant="body1" color="text.secondary">
                            {fleet.businessName} / {fleet.name}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </DashboardCard>
    );
}

export default RecentFleets;
